module.exports = __webpack_public_path__ + "img/flavor_mango.a1ecdcd4.png";